import styled from 'styled-components';
import { Drawer } from 'components/atoms/drawer';
import { Menu } from 'components/atoms/dropdown';
import { Grid } from 'components/atoms/grid';
import { Switcher } from 'components/atoms/switcher';
import { ProductiveHeading07 } from 'components/styles';

export const SUContainer = styled.div`
  height: 100%;
  display: flex;
`;

export const Container = styled.div<{ isFullScreen?: boolean }>`
  background: var(--white-100);
  display: grid;
  grid-template-columns: minmax(550px, 1fr) 392px;
  box-shadow: var(--shadow-08);
  max-width: 942px;
  margin: auto;
  height: 100%;

  @media screen and (min-width: 1320px) {
    & {
      grid-template-columns: minmax(600px, 1fr) 392px;
      max-width: 1000px;
      overflow: auto;
    }
  }
`;

export const Wrapper = styled.div`
  padding: var(--spacing-03) var(--spacing-05);
  padding-left: var(--left-spacing);
  align-items: center;
  display: flex;
  justify-content: flex-end;
  border: 1px solid var(--border-color);
`;

export const Tabs = styled(Menu)`
  padding: 0;
  border-bottom: none;
  flex: 1;
`;

export const StatusUpdateDrawer = styled(Drawer)<{
  large: boolean;
  visible: boolean;
}>`
  z-index: var(--zindex-modal);
  order: 2;
  &.status-update-drawer {
    transition: width 0.2s, transform 0.15s;
  }
  &.status-update-drawer {
    width: ${({ large }) => (large ? '708px !important' : '1100px !important')};
    width: ${({ visible }) => (!visible ? '0px ! important' : '')};
  }
  .ant-drawer-body {
    padding: 0;
  }
  & .fullscreen {
    height: 100%;
  }
`;

export const GridContainer = styled.div`
  padding: 0 var(--spacing-05);
  padding-left: var(--left-spacing);
  height: calc(100vh - var(--spacing-12));
  .ag-row-selected {
    background-color: var(--ag-row-hover-color) !important;
  }
`;

export const StyledGrid = styled(Grid)`
  .ag-center-cols-container .ag-row {
    pointer-events: initial !important;
  }
  .ag-overlay-no-rows-wrapper {
    display: flex;
    text-align: unset;
    pointer-events: auto;
  }
  .ag-row {
    border-color: var(--table-border-color);
    cursor: pointer;
  }
  .ag-header {
    display: none;
  }
  .ag-row-focus {
    background: transparent;
  }
`;

export const StatusTitle = styled.div<{ isUnread: boolean }>`
  margin-right: var(--spacing-03);
  ${({ isUnread }) => (!isUnread ? ProductiveHeading07 : '')};
`;

export const SwitcherButton = styled(Switcher.Button)`
  height: var(--spacing-07) !important;
  &:hover {
    background-color: var(--coolest-gray-10);
  }
`;
export const DateWrapper = styled.div`
  width: 100%;
  text-align: right;
  padding-right: var(--spacing-03);
  color: var(--gray-60);
`;

export const UnreadIcon = styled.div`
  height: var(--spacing-03);
  width: var(--spacing-03);
  border-radius: 50%;
  background-color: var(--red-60);
  position: absolute;
  top: var(--spacing-02);
  left: var(--spacing-02);
`;

export const DraftWrapper = styled.div`
  color: var(--red-60);
  text-align: right;
  width: 100%;
`;

export const CenterWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Spacer = styled.div`
  margin-bottom: var(--spacing-03);
`;
